// @Version: 1.0.0
export enum DESIGNLANG {
   DEFAULT = "~~DEFAULT-LANG~~",
   PROD = 'de'
}

export enum DESIGNSESSION {
   OPTION = 'design_param_option',
   PROJECTNAME = 'design_param_projectname',
   APPLICATION = 'design_param_application'
}



export enum DESIGN {
   OPTION = '-1'
}

export enum DESIGNTYPOGRAPHY {
   headline1 = "headline-1",
   headline2 = "headline-2",
   headline3 = "headline-3",
   headline4 = "headline-4",
   headline5 = "headline-5",
   headline6 = "headline-6",
   subtitle1 = "subtitle-1",
   subtitle2 = "subtitle-2",
   body2 = "body-2",
   body1 = "body-1",
   caption = "caption",
   button = "button",
   plus = "plus",
   content = "content",
   h5 = "h5",
   h6 = "h6"
}

export enum DESIGN_TYPOGRAPHY_PROPERTY {
   fontsize = "-fontsize",
   fontweight = "-fontweight",
   letterspacing = "-letterspacing",
   lineheight = "-lineheight",
   fontfamily = "-fontfamily"
}